import { createContext, useContext, useState } from 'react';

const TenantContext = createContext();

const TENANTS = [
  { id: 'all', name: 'All Tenants' },
  { id: 'cachee', name: 'Cachee' },
  { id: 'l100', name: 'L100.ai' },
  { id: 'supersearch', name: 'SuperSearch.ai' },
  { id: 'mirror1', name: 'Mirror1.ai' },
  { id: 'babykong', name: 'BabyKong.ai' },
];

export const TenantProvider = ({ children }) => {
  const [currentTenant, setCurrentTenant] = useState('all');
  const [isImpersonating, setIsImpersonating] = useState(false);

  const selectTenant = (tenantId) => {
    setCurrentTenant(tenantId);
    setIsImpersonating(tenantId !== 'all');
  };

  const exitImpersonation = () => {
    setCurrentTenant('all');
    setIsImpersonating(false);
  };

  const getCurrentTenantData = () => {
    return TENANTS.find(t => t.id === currentTenant) || TENANTS[0];
  };

  return (
    <TenantContext.Provider value={{
      currentTenant,
      tenants: TENANTS,
      isImpersonating,
      selectTenant,
      exitImpersonation,
      getCurrentTenantData
    }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

export default TenantContext;
